import { z } from "zod";

import { searchFiltersSchema, searchHistorySchema } from "../commons";

export const createSearchHistorySchema = z.object({
  filters: searchFiltersSchema.optional(),
  name: z.string().nonempty(),
  query: z.string().optional(),
});

export type CreateSearchHistory = z.infer<typeof createSearchHistorySchema>;

export const createSearchHistoryRequestSchema = z.object({
  body: createSearchHistorySchema,
});

export type CreateSearchHistoryRequest = z.infer<
  typeof createSearchHistoryRequestSchema
>;

export const createSearchHistoryResponseSchema = searchHistorySchema;

export type CreateSearchHistoryResponse = z.infer<
  typeof createSearchHistoryResponseSchema
>;

export const updateSearchHistorySchema = z.object({
  name: z.string().nonempty(),
});

export type UpdateSearchHistory = z.infer<typeof updateSearchHistorySchema>;

export const updateSearchHistoryParamsSchema = z.object({
  id: z.string().nonempty(),
});

export const updateSearchHistoryRequestSchema = z.object({
  body: updateSearchHistorySchema,
  params: updateSearchHistoryParamsSchema,
});

export type UpdateSearchHistoryRequest = z.infer<
  typeof updateSearchHistoryRequestSchema
>;

export const updateSearchHistoryResponseSchema = searchHistorySchema;

export type UpdateSearchHistoryResponse = z.infer<
  typeof updateSearchHistoryResponseSchema
>;

export const deleteSearchHistoryParamsSchema = z.object({
  id: z.string().nonempty(),
});

export const deleteSearchHistoryRequestSchema = z.object({
  params: deleteSearchHistoryParamsSchema,
});

export type DeleteSearchHistoryRequest = z.infer<
  typeof deleteSearchHistoryRequestSchema
>;

export const listSearchHistoryResponseSchema = z.array(searchHistorySchema);

export type ListSearchHistoryResponse = z.infer<
  typeof listSearchHistoryResponseSchema
>;
